import React, { useState, useContext, useEffect, useRef } from "react";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { useSelector } from "react-redux";
import {
     Chart,
     ChartSeries,
     ChartSeriesItem,
     ChartCategoryAxis,
     ChartCategoryAxisItem,
     ChartTitle,
     ChartLegend,
} from "@progress/kendo-react-charts";
import { useDispatch } from "react-redux";
import { Context } from "../../../../_context/Store";
import UiSelect from "../../../_uiComponents/common/form/UiSelectDefault";
import UiDateRangePicker from "../../../_uiMocks/_uiComponents/UiDateRangePicker";
import { dashboardConstants } from "../../../../_redux/_constants";
import  {getRewardIssueByCampaignDispatchDownloadRequest} from "../../../../_redux/_actions"
import {
     timeFormatUtcToLocal,
     getObjectFromArray,
     getDateRangeString,
     showCustomLoading,
} from "../../../../_helpers/support.services";
import ExportToExcelWithApi from "../../../_uiComponents/common/ExportToExcelWithApi";
import { InnerLoader } from "../../../_uiComponents/common/UiLoadingSpinner";

export default function RewardIssuedByCampaign(props) {

     const actionDispatch = useDispatch();
     const [state, dispatch] = useContext(Context);
     const [startDate, setStartDate] = useState(null);
     const [endDate, setEndDate] = useState(null);
     const [jobRoleId, setJobRoleId] = useState("");
     const [areaId, setAreaId] = useState("");
     const [exportData, setExportData] = useState(null);
     const downloadFileName = useRef(null);

     const { dashBoardRewardIssueCampaignSummary, areaList, dashboardRewardIssueDownload, loader } = useSelector(
          (state) => {
               return {
                    dashBoardRewardIssueCampaignSummary:
                         state.dashboard.dashBoardRewardIssueCampaignSummary,
                    areaList: state.dashboard.areaList,
                    dashboardRewardIssueDownload:state.dashboard.dashboardRewardIssueDownload,
                    loader: state.loading,
               };
          },
     );

     const getData = (
          startDate = null,
          endDate = null,
          jobRoleId = null,
          areaId = null,
     ) => {
          downloadFileName.current =
               "reward_issue_by_campaign_user_" +
               getObjectFromArray(
                    props.applicationId,
                    "value",
                    dashboardConstants.userTypes,
               ).label +
               "_job_role_" +
               getObjectFromArray(jobRoleId, "value", props.jobRolesOptions)
                    .label +
               "_date_" +
               getDateRangeString(startDate, endDate) +
               "_area_" +
               getObjectFromArray(areaId, "value", [
                    {
                         value: "0",
                         label: "All",
                    },
                    ...areaList.map(function (item) {
                         return {
                              label: item.area,
                              value: item.area,
                         };
                    }),
               ]).label;

          props.getData(
               startDate,
               endDate,
               jobRoleId,
               areaId,
               props.applicationId,
          );
     };

     useEffect(()=>{
          setExportData(dashboardRewardIssueDownload)
     },[dashboardRewardIssueDownload])

     const fetchDataForExport = async (onDownloadComplete) => {
          try {
          actionDispatch(getRewardIssueByCampaignDispatchDownloadRequest({
                  downloadType:"rewardissued",
                  startDate,
                  endDate,
                  jobRoleId,
                  areaId,
                  applicationId: props.applicationId
               }));
          } catch (error) {
               onDownloadComplete(false);
              console.error("Error fetching data for export:", error);
          }
      };

     useEffect(
          function () {
               getData(startDate, endDate, jobRoleId, areaId);
          },
          [props.applicationId],
     );

     return (
          <>
               <div className="sba-chart-top-section sb-summary-chart-top">
               {showCustomLoading(
                    [dashboardConstants.DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_REQUEST],
                    loader.pendingRequests
               ) && <InnerLoader/>}
                    <h5>Reward Issued By Campaign</h5>
                         <ExportToExcelWithApi 
                              name={downloadFileName.current}
                              data={exportData}
                              onDownloadClick={(onDownloadComplete) => fetchDataForExport(onDownloadComplete)}
                         />
                    <div className="sba-chart-top-select-col">
                         <UiSelect
                              options={[
                                   {
                                        value: "0",
                                        label: "All",
                                   },
                                   ...areaList.map(function (item) {
                                        return {
                                             label: item.area,
                                             value: item.area,
                                        };
                                   }),
                              ]}
                              label="Area"
                              value={areaId}
                              defaultValue={0}
                              handleChange={(value) => {
                                   getData(
                                        startDate,
                                        endDate,
                                        jobRoleId,
                                        value,
                                   );
                                   setAreaId(value);
                              }}
                         />
                    </div>
                    <div className="sba-chart-top-select-col">
                         <UiSelect
                              options={props.jobRolesOptions}
                              label="Job Role"
                              value={jobRoleId}
                              defaultValue={props.jobRolesOptions[0].value}
                              handleChange={(value) => {
                                   getData(startDate, endDate, value, areaId);
                                   setJobRoleId(value);
                              }}
                         />
                    </div>
                    <div className="sba-chart-top-range-picker">
                         <UiDateRangePicker
                              onChange={(value) => {
                                   if (value[0] && value[1]) {
                                        const startDate = timeFormatUtcToLocal(
                                             value[0],
                                        );
                                        const endDate = timeFormatUtcToLocal(
                                             value[1],
                                        );
                                        setStartDate(startDate);
                                        setEndDate(endDate);

                                        getData(
                                             startDate,
                                             endDate,
                                             jobRoleId,
                                             areaId,
                                        );
                                   } else {
                                        if (!value[0] && !value[1]) {
                                             setStartDate(null);
                                             setEndDate(null);
                                             getData(
                                                  null,
                                                  null,
                                                  jobRoleId,
                                                  areaId,
                                             );
                                        }
                                   }
                              }}
                         />
                    </div>
                    <div className="sba-drag-handle">
                         <DehazeIcon />
                    </div>
               </div>

               <div
                    className={
                         state.ui_sidebar_open === true
                              ? "collapse-chart"
                              : "expand-chart"
                    }
               >
                    <Chart
                         transitions={false}
                         style={{
                              width: "100%",
                              height: "100%",
                              position: "center center",
                         }}
                    >
                         <ChartLegend
                              position="bottom"
                              orientation="horizontal"
                         />
                         <ChartCategoryAxis>
                              <ChartCategoryAxisItem
                                   labels={{
                                        rotation: "auto",
                                   }}
                                   categories={
                                        dashBoardRewardIssueCampaignSummary?.categories
                                   }
                              />
                         </ChartCategoryAxis>

                         <ChartSeries>
                              <ChartSeriesItem
                                   type="column"
                                   tooltip={{
                                        visible: true,
                                   }}
                                   data={
                                        dashBoardRewardIssueCampaignSummary?.data
                                   }
                              />
                         </ChartSeries>
                    </Chart>
               </div>
          </>
     );
}
